// 将 key 加上前缀：ovo.
export default function VoGenerator(data) {
    if (Object.keys(data).length > 0) {
        return Object.keys(data).map(key => {
            const newKey = "ovo." + key;
            return {[newKey]: data[key]}
        }).reduce((prev, next) => ({...prev, ...next}));
    } else {
        return {};
    }
}
